import addDays from 'date-fns/addDays'
import toDate from 'date-fns/toDate'

const getFutureDate = (datetime, days = 5) => {
  try {
    const futureDate = addDays(toDate(datetime), days)
    const today = new Date()

    return futureDate > today ? today.toISOString() : futureDate.toISOString()
  } catch (error) {
    return null
  }
}

export default getFutureDate



// WEBPACK FOOTER //
// ./src/utility/getFutureDate.js